import * as React from 'react';
import { useState, useContext, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { UIContext } from '../store/uiContext';

const Notification: React.FC = () => {
  const { notifications, hideNotification } = useContext(UIContext);
  const [open, setOpen] = useState(false);

  const notification = notifications[0];

  useEffect(() => {
    setOpen(!!notification);
  }, [notification]);

  const handleClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    hideNotification();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={notification?.hideDuration || 4000}
      onClose={handleClose}
      TransitionProps={{
        onExited: handleExited,
      }}
    >
      {notification ? (
        <Alert
          onClose={handleClose}
          severity={notification.type || 'info'}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
};

export default Notification;
